import React from 'react'
import { NotificationWireResource } from '@core/Data/Contentful/notification'
import { Button } from '@mobi/component-library/Common/V2'
import { appHistory } from '@core/Utils/routing/history'

type Props = {
  notification: NotificationWireResource
}

const NotificationLink = ({ notification }: Props) => {
  if (!notification.NavigationLink || !notification.NavigationLinkText) return null

  return (
    <Button
      onClick={() => {
        if (!notification.NavigationLink) {
          return
        }

        if (
          notification.NavigationLink.startsWith('https://') &&
          new URL(notification.NavigationLink).origin !== window.location.origin
        ) {
          window.open(notification.NavigationLink, '_blank')
          return
        }

        appHistory.push(notification.NavigationLink)
      }}
      color='secondary_outline'
      size='sm'
      role='link'
      data-internaltrackingcode={notification.InternalTrackingCode || ''}
    >
      {notification.NavigationLinkText}
    </Button>
  )
}

export default NotificationLink
